import React, { PropTypes } from "react";
import { connect } from "react-redux";
import UpcomingLandingWebinars from "components/Dashboard/UpcomingWebinars/UpcomingLandingWebinars";
import UpcomingWebinarLandingItem from "components/Dashboard/UpcomingWebinars/UpcomingWebinarLandingItem";
import actions from "actions";
import constants from "constants";
import { push } from "redux-router";
import _ from "lodash";

const { LANDING_WEBINARS } = constants;

const { subscribeWebinarSaga, unsubscribeWebinarSaga } = actions;

class LandingWebinars extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showBack: false,
      showForward: false,
    };
    this.scrollRoot = null;
    this.scrollRootRef = (el) => {
      this.scrollRoot = el;
    };
  }

  webinars = () =>
    this.props.webinars.map((webinar) => {
      return (
        <div className="landingWebinarContainer">
          <UpcomingWebinarLandingItem
            key={webinar.id}
            webinar={webinar}
            userRole={this.props.userRole}
            toggleSubscription={() => this.toggleSubscription(webinar)}
          />
        </div>
      );
    });

  toggleSubscription = (webinar) => {
    const { dispatch, isLogged } = this.props;

    if (!isLogged) {
      dispatch(push("/users/sign_in"));
      return;
    }

    if (webinar.subscription_id)
      this.props.unsubscribeWebinar(webinar.subscription_id, webinar.id);
    else this.props.subscribeWebinar(webinar);
  };

  scrollBack() {
    const el = document.getElementsByClassName("landingWebinarContainer")[0];
    const scrollLeft =
      this.scrollRoot.scrollLeft - el.offsetWidth > 0
        ? this.scrollRoot.scrollLeft - el.offsetWidth
        : 0;
    this.scrollRoot.scrollLeft = scrollLeft;
    this.setState({
      showBack: scrollLeft > 0,
      showForward:
        scrollLeft < this.scrollRoot.scrollWidth - this.scrollRoot.offsetWidth,
    });
  }
  scrollForward() {
    const el = document.getElementsByClassName("landingWebinarContainer")[0];
    const scrollLeft =
      this.scrollRoot.scrollLeft + el.offsetWidth >
      this.scrollRoot.scrollWidth - this.scrollRoot.offsetWidth
        ? this.scrollRoot.scrollWidth - this.scrollRoot.offsetWidth
        : this.scrollRoot.scrollLeft + el.offsetWidth;
    this.scrollRoot.scrollLeft = scrollLeft;
    this.setState({
      showBack: scrollLeft > 0,
      showForward:
        scrollLeft < this.scrollRoot.scrollWidth - this.scrollRoot.offsetWidth,
    });
  }

  componentDidUpdate() {
    if (
      !this.state.showForward &&
      this.scrollRoot &&
      this.scrollRoot.scrollWidth > this.scrollRoot.offsetWidth &&
      this.scrollRoot.scrollLeft === 0 &&
      this.scrollRoot.offsetWidth > 0
    ) {
      this.setState({
        showBack: this.state.showBack,
        showForward: true,
      });
    }
  }

  render() {
    return (
      <UpcomingLandingWebinars
        isMobile={this.props.isMobile}
        scrollBack={this.scrollBack.bind(this)}
        scrollForward={this.scrollForward.bind(this)}
        scrollRootRef={this.scrollRootRef}
        showBack={this.state.showBack}
        showForward={this.state.showForward}
        nextPage={this.props.nextPage}
        webinars={(noTitle) => this.webinars(noTitle)}
        pagination={this.props.pages > this.props.page}
        count={this.props.count}
      />
    );
  }
}

// LandingWebinars.propTypes = {
//   webinars: PropTypes.array,
//   subscribeWebinar: PropTypes.func,
//   unsubscribeWebinar: PropTypes.func,
//   pages: PropTypes.integer
// }

const mapStateToProps = (state) => ({
  pages: state.webinars[LANDING_WEBINARS].pages,
  isLogged: !_.isEmpty(state.users.user),
  userRole: state.users.user.user_type,
});

const mapDispatchToProps = (dispatch) => ({
  subscribeWebinar: (webinar) => dispatch(subscribeWebinarSaga(webinar, true)),
  unsubscribeWebinar: (id, weinbarId) =>
    dispatch(unsubscribeWebinarSaga(id, weinbarId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingWebinars);



// WEBPACK FOOTER //
// ./src/containers/Dashboard/LandingWebinars/LandingWebinars.jsx